import classNames from 'classnames';
import React from 'react';
import Flag from 'react-world-flags';
import companyLogoPlaceholder from '../../../../public/assets/img/company-logo-placeholder.png';
import { IDirectoryEntry } from 'services/CrmApi/types/DirectoryEntry';
import { useResponsive } from 'containers/CRM/hooks/useResponsive';
import { CompanyPageTitleRightPart } from './CompanyPageTitleRightPart';

export interface ICompanyPageTitleProps {
  companyType: string;
  primaryClassName?: string;
  directoryEntry?: IDirectoryEntry;
}

export const CompanyPageTitle: React.FC<ICompanyPageTitleProps> = ({ 
  companyType, primaryClassName = '', directoryEntry
}) => {
  const { isDesktop, isDesktopHD } = useResponsive();
  return (
    <div className="company-page-title flex justify-between items-center">
      <div className="font-noe-display flex items-center gap-[10px]">
        <span className="company-logo w-[60px] h-auto">
          <img src={companyLogoPlaceholder} alt="Company logo" className="w-[60px] h-[60px]" />
        </span>
        <div className="flex flex-col ">
          <div className="flex gap-[10px] items-baseline">
            <h1 className={classNames('primary-title font-noe-display text-[26px] leading-normal max-w-[70vw] text-black font-normal m-0 text-ellipsis overflow-hidden whitespace-nowrap', primaryClassName)}>
              {directoryEntry?.fullName ?? ''}
            </h1>
            {directoryEntry?.country?.code && <Flag code={directoryEntry?.country?.code} className="relative top-[2px] w-[18px] h-[18px]" />}
          </div>
          <p className="font-pt-sans text-[15px] text-black m-0">{companyType}</p>
        </div>
      </div>
      {(isDesktop || isDesktopHD) && (
        <CompanyPageTitleRightPart directoryEntry={directoryEntry} />
      )}
    </div>
  );
}
